import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTableST = props => {
    let { STDeprTo_uV, STElevTo_uV, STDeprTo_Lead, STElevTo_Lead, loc, needIntervals } = props;

    STDeprTo_uV = STDeprTo_uV?.val;
    STElevTo_uV = STElevTo_uV?.val;
    STDeprTo_Lead = STDeprTo_Lead?.val;
    STElevTo_Lead = STElevTo_Lead?.val;

    const deprVal = STDeprTo_uV !== undefined && STDeprTo_uV !== null ? STDeprTo_uV : undefined;
    const deprLead = STDeprTo_Lead !== undefined && STDeprTo_Lead !== null ? " (" + STDeprTo_Lead + ")" : "";

    const elevVal = STElevTo_uV !== undefined && STElevTo_uV !== null ? STElevTo_uV : undefined;
    const elevLead = STElevTo_Lead !== undefined && STElevTo_Lead !== null ? " (" + STElevTo_Lead + ")" : "";

    return (
        <table className="prm-table prm-table-ST">
            <tbody>
                <tr>
                    <td className="prm-title">{loc("report.params.ST_depr_to")}</td>
                    {needIntervals ? (
                        <>
                            <td className="prm-data">{deprVal}</td>
                            <td className="prm-units">{loc("units.uV")}</td>
                            <td className="prm-units">{deprLead}</td>
                        </>
                    ) : (
                        <>
                            <td className="prm-data"></td>
                            <td className="prm-units"></td>
                            <td className="prm-units"></td>
                        </>
                    )}
                </tr>
                <tr>
                    <td className="prm-title">{loc("report.params.ST_elev_to")}</td>
                    {needIntervals ? (
                        <>
                            <td className="prm-data">{elevVal}</td>
                            <td className="prm-units">{loc("units.uV")}</td>
                            <td className="prm-units">{elevLead}</td>
                        </>
                    ) : (
                        <>
                            <td className="prm-data"></td>
                            <td className="prm-units"></td>
                            <td className="prm-units"></td>
                        </>
                    )}
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTableST);
